<template>
  <section class="c-order-details">
    <div class="c-order-details__row">
      <div class="c-order-details__column u-margin-bottom-small">
        <h2 class="c-order-details__header t-heading-6">
          Shipping Address
        </h2>
        <!-- eslint-disable vue/no-v-html -->
        <p
          class="c-order-details__indented"
          v-html="order.shippingAddress"
        />
      </div>
      <div class="c-order-details__column u-margin-bottom-small">
        <h2 class="c-order-details__header t-heading-6">
          Billing Address
        </h2>
        <!-- eslint-disable vue/no-v-html -->
        <p
          class="c-order-details__indented"
          v-html="order.billingAddress"
        />
      </div>
    </div>
    <div class="c-order-details__row">
      <div class="c-order-details__column u-margin-bottom-small">
        <h2 class="c-order-details__header t-heading-6">
          Shipping Method
        </h2>
        <p class="c-order-details__content">
          <template v-if="order.shippingMethods.length">
            <span
              v-for="(method, index) in order.shippingMethods"
              :key="index"
            >
              {{ method.title }}<br>
            </span>
          </template>
        </p>
      </div>
      <div class="c-order-details__column u-margin-bottom-small">
        <h2 class="c-order-details__header t-heading-6">
          Payment Method
        </h2>
        <p class="c-order-details__content c-order-details__indented">
          <template v-if="order.transactions.length">
            <span
              v-for="(transaction, index) in order.transactions"
              :key="index"
            >
              <template v-if="transaction.payment_details.credit_card_company">
                {{ transaction.payment_details.credit_card_company }} ending in {{ transaction.payment_details.credit_card_number.slice(-4) }}
                <br>
              </template>
              <template v-else>
                Other Payment Method (non-card)
                <br>
              </template>
            </span>
          </template>
          <template v-else>
            No Transaction
          </template>
        </p>
      </div>
    </div>
    <div class="c-order-details__row">
      <div class="c-order-details__column u-margin-bottom-small">
        <h2 class="c-order-details__header t-heading-6">
          Status
        </h2>
        <p class="c-order-details__indented">
          Fulfillment Status: {{ order.labels.fulfillmentStatus }}<br>
          Financial Status: {{ order.labels.financialStatus ? order.labels.financialStatus : 'No Transaction' }}
        </p>
      </div>    
    </div>
    <a
      v-if="order.trackingUrl"
      class="t-link"
      :href="order.trackingUrl"
    >
      Track Package
    </a>
    <order-items :items="order.lineItems" />
    <order-totals
      :subtotal="order.subtotalPrice"
      :tax="order.taxPrice"
      :shipping="order.shippingPrice"
      :discounts="order.discounts"
      :price="order.totalPrice"
    />
  </section>
</template>

<script>
import OrderItems from './OrderItems';
import OrderTotals from './OrderTotals';

export default {
  name: "AccountOrder",
  components: {
    OrderItems,
    OrderTotals,
  },
  props: {
    order: {
      type: Object,
      default: () => ({}),
    },
  }
}
</script>

<style lang="scss" scoped>
.c-order-details {
  &__row {
    display: flex;
    flex-direction: column;

    @include respond-min('tab-port') {
      flex-direction: row;
    }
  }

  &__column {
    flex: 1;
  }

  &__indented {
    padding-left: rem(8px);    
  }
}
</style>